import { useAppSelector, useAppDispatch } from "../hooks/reduxHooks";
import { openDrawer } from "../store/layout";

//material-ui
import { AppBar, Toolbar, Typography, IconButton, Badge } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import PageButtons from "./PageButtons";
import Alarm from "../components/Alarm";

interface TopBarProps {
	children: JSX.Element;
}

const TopBar = (props: TopBarProps) => {
	const { children } = props;

	const dispatch = useAppDispatch();

	const pageTitle = useAppSelector((state) => state.layout.pageTitle);
	const updateAvailable = useAppSelector((state) => state.layout.updateAvailable);

	return (
		<AppBar id="appHeader" position="sticky">
			<Toolbar>
				<IconButton color="inherit" aria-label="open drawer" onClick={() => dispatch(openDrawer())} edge="start" size="large">
					<Badge color="error" variant="dot" invisible={!updateAvailable}>
						<MenuIcon />
					</Badge>
				</IconButton>

				<Typography variant="h6" noWrap>
					{pageTitle} <Alarm />
				</Typography>
				<PageButtons />
			</Toolbar>
			{children}
		</AppBar>
	);
};

export default TopBar;
